<template>
  <SingleColumn>
    <template #header>
      <h1 class="text-3xl font-bold text-white">
        Podcast importieren
      </h1>
    </template>
    <template #content>
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <div class="py-6 px-4 sm:p-6 lg:pb-8">
          <ImportForm :resource="resource" :errors="errors" />
        </div>
        <div class="px-6 pb-6 divide-y divide-gray-200">
          <div class="flex justify-end">
            <CancelButton :to="{name: 'dashboard'}" class="mr-2">
              Abbrechen
            </CancelButton>
            <SubmitButton @click="onSubmit" :load="creating">
              Importieren
            </SubmitButton>
          </div>
        </div>
      </div>
    </template>
  </SingleColumn>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useCreateResource } from '@/client/actions';

const target = computed(() => '/api/podcasts:import');

const router = useRouter();
const action = useCreateResource(target);

const { resource, errors, message, create, creating } = action;

const onSuccess = () => router.push({name: 'dashboard'});
const onSubmit = () => create(onSuccess);
</script>
